import { InvoiceStatus } from '~/invoice/enums';

export const getColorForInvoiceStatus = (status: InvoiceStatus) => {
  switch (status) {
    case InvoiceStatus.DRAFT:
      return 'warning';
    case InvoiceStatus.SUBMITTED:
      return 'primary';
    case InvoiceStatus.AUTHORISED:
      return 'secondary';
    case InvoiceStatus.PAID:
      return 'success';
    default:
      return 'default';
  }
};
